import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

export const WaitingState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <ClockIcon className="h-16 w-16 text-gray-300 mb-4" />
      <p className="text-lg font-medium text-gray-500">
        Report for today has not been generated yet
      </p>
      <p className="text-sm text-gray-400 mt-2">
        The report will appear automatically when FTP data arrives
      </p>
    </div>
  );
};
